// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"c5cae4ec","413":"a94e22c5","915":"75758c05","963":"72cfe402"}[chunkId] + ".chunk.js";
};